import React, { useCallback, useEffect, useState } from "react";
import MissingPatchAging from "./MissingPatchAging";
import MissingPatchesBySeverity from "./MissingPatchesBySeverity";
import PatchCompliance from "./PatchCompliance";
import PatchSummaryCards from "./PatchSummaryCards";
import FailedPatchDeployments from "./FailedPatchDeployments";
import AutomatedPatchDeployment from "./AutomatedPatchDeployment";
import TestAndApproveOverview from "./TestAndApproveOverview";
import PatchCatalogOverview from "./PatchCatalogOverview";
import styles from "./Patch.module.css";
import API from "common-ui-components/components/utils/API";

const Patch = () => {
 
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOverview = useCallback(async (signal) => {
    try {
      const response = await API.get("/patch/overview", { signal });
      if (!signal.aborted && response?.status?.success) {
        setOverview(response.body || {});
      }
    } catch (error) {
      if (!signal.aborted) {
        console.error("Failed to load patch overview:", error);
      }
    } finally {
      if (!signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchOverview(controller.signal);
    return () => controller.abort();
  }, [fetchOverview]);

  return (
    <div className={styles.patchPage}>
      <PatchSummaryCards overview={overview} loading={loading} />
      <div className={styles.overviewGrid}>
        <MissingPatchesBySeverity
          total={overview?.totalMissingPatches ?? 0}
          critical={overview?.totalMissingCriticalPatches ?? 0}
          important={overview?.totalMissingHighPatches ?? 0}
          medium={overview?.totalMissingMediumPatches ?? 0}
          low={overview?.totalMissingLowPatches ?? 0}
          unrated={overview?.totalMissingUnratedPatches ?? 0}
        />
        <PatchCompliance overview={overview} loading={loading} />
        <MissingPatchAging />
        <FailedPatchDeployments />
        <AutomatedPatchDeployment />
        <TestAndApproveOverview overview={overview} loading={loading} />
        <PatchCatalogOverview />
      </div>
    </div>
  );
};

export default Patch;
